export type RunnerStatus = "loading" | "ready" | "error";

export interface RunnerStatusMessage {
  type: "runner-status";
  status: RunnerStatus;
  gameId?: string;
  message?: string;
}

export interface GameResizeMessage {
  type: "game-resize";
  gameId?: string;
  height: number;
}

export function postRunnerStatus(
  target: Window,
  message: RunnerStatusMessage,
  origin: string = window.location.origin
): void {
  target.postMessage(message, origin);
}

export function postGameResize(
  target: Window,
  message: GameResizeMessage,
  origin: string = window.location.origin
): void {
  target.postMessage(message, origin);
}
